import React, { useState, useEffect } from 'react';
import { Button, IconButton} from '@material-ui/core'
import ExportButton from './exportButton';
import Modal from 'react-bootstrap/Modal';
import { makeStyles } from '@material-ui/core/styles';
import { Form } from 'react-bootstrap';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { TbFileCertificate } from "react-icons/tb";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { useSelector } from 'react-redux';
import { _ } from '../../functions/translator';
import { MdDelete } from "react-icons/md";

function ExportCertificates (props) {
    const [show, setShow] = useState(false);
    const [selectedValue, setSelectedValue] = useState('figuregroup')
    const [isChecked, setIsChecked] = useState(false);
    const [manualSignatures, setManualSignatures] = useState(false);
    const [numberOfSignatures, setNumberOfSignatures] = useState(0);
    const [charges, setCharges] = useState([]);
    const [withImages, setWithImages] = useState(false);
    const [showSuccesToast, setShowSuccessToast] = useState(false);
    const [showFailureToast, setShowFailureToast] = useState(false);

    const { selectedCardsGroups, projectData} = useSelector(state => ({
        selectedCardsGroups: state.selectedCardsGroups,
        projectData: state.projectData
    }))

    
    let cardsGroupsSelectedCertificates = 0
    if(props.popUpMenu === true){
        if (selectedCardsGroups !== "none") {
            for (let i = 0; i < selectedCardsGroups.length; i++) {
                const cardGroupId = selectedCardsGroups[i];
                const cardGroup = projectData.cards_groups[cardGroupId];
                if (cardGroup.attributes.status === "closed"){
                    cardsGroupsSelectedCertificates++
                }
            }
        }
    }

    let disabledButton = false

    useEffect(() => {
        // Notify the parent component about the button status
        props.onStateChange && props.onStateChange(disabledButton);
    }, [disabledButton]);

    if(props.popUpMenu &&  cardsGroupsSelectedCertificates === 0){
        disabledButton = true
    }


    let backgroundColor = '#ff5300'
    let opacityButton = 1

    if(props.popUpMenu){
        backgroundColor = ''
        if (disabledButton){
            opacityButton = 0.3
        }
    }

    const handleClose = () => setShow(false);
    const handleShow = () => {
        if(!disabledButton){
            setShow(true)
        }
    };

    const handleChange = (e) => {
        setSelectedValue(e.target.value);
    };

    const handleChargesChange = (event, i) => {
        const charge = event.target.value;
        const updatedCharges = [...charges];
        updatedCharges[i] = charge;
        setCharges(updatedCharges);
    };

    const handleCheckboxChange = (e) => {
        setIsChecked(e.target.checked);
      
    };

    const handleManualSignatureChange = (e) => {
        setManualSignatures(e.target.checked);
        if (!e.target.checked) {
            setCharges([]);
            setNumberOfSignatures(0);
        }
    };

    const handleSetWithImages = (e) => {
        setWithImages(e.target.checked);
    };

    const handleNumberChange = (e) => {
        setNumberOfSignatures(parseInt(e.target.value));
        if (parseInt(e.target.value) === 0) {
            setCharges([]);
        } else {
            const updatedCharges = [...charges].slice(0, parseInt(e.target.value));
            setCharges(updatedCharges);
        }
    };

    const handleChildStateChange = (newState, response) => {
        setShow(newState);
        if (response) {
            setShowSuccessToast(true);
        } else {
            setShowFailureToast(true);
        }
    };

    const handleDeleteCharge = (i) => {
        const updatedCharges = [...charges]
        updatedCharges.splice(i,1)
        setCharges(updatedCharges);
        setNumberOfSignatures(prev => prev - 1);
    };

    const renderSelectInputs = () => {
        const selectInputs = [];
        for (let i = 0; i < numberOfSignatures; i++) {
            selectInputs.push(
                <Form.Group className='mt-2' key={i} controlId={`select-signature-${i}`}>
                    <Form.Label>{_('Seleccionar Firmante')} {i + 1}:</Form.Label>
                    <div className='d-flex flex-row'>
                        <Form.Control type="text" placeholder="Escribe un Cargo" value={charges[i] || ''} name="charge" required onChange={(event) => handleChargesChange(event, i)} />
                        <IconButton
                            onClick={() => handleDeleteCharge(i)}
                            aria-label="delete"
                            color="secondary"
                            style={{ marginLeft: '10px' }}
                        >
                            <MdDelete />
                        </IconButton>
                    </div>
                </Form.Group>
            );
        }
        return selectInputs;
    };

    const isAnySelectEmpty = () => {
        if (numberOfSignatures === 0) return false;
        if (charges.length < numberOfSignatures) return true
        return charges.some((charge) => !charge || charge === '');
    };

    const useStyles = makeStyles((theme) => ({
        root: {
          display: 'flex',
          '& > * + *': {
            marginLeft: theme.spacing(2),
          },
        },
      }));

    const classes = useStyles();
    return(
        <>
            <Snackbar className='w-100 p-0' onClose={() => setShowSuccessToast(false)} open={showSuccesToast} autoHideDuration={4000}>
                <MuiAlert elevation={6} variant="filled" severity="success">
                    <p className='text-center w-100 m-0'>
                        {_('Estamos preparando los certificados. Te enviaremos un link a tu correo cuando la descarga esté lista')}.
                    </p>
                </MuiAlert>
            </Snackbar>
            <Snackbar className='w-100 p-0' onClose={() => setShowFailureToast(false)} open={showFailureToast} autoHideDuration={4000}>
                <MuiAlert elevation={6} variant="filled" severity="error">
                    <p className='text-center w-100 m-0'>
                        ¡{_('Ha ocurrido un error al exportar')} {_('certificados')}!
                    </p>
                </MuiAlert>
            </Snackbar>
            <Button 
                    onClick={handleShow} 
                    size='small' 
                    disabled={disabledButton} 
                    style={{width:'100%', 
                        height:'100%', 
                        background: backgroundColor, 
                        color:"#ffffff", 
                        textTransform: 'none', 
                        fontWeight:700, 
                        marginBottom:'10px', 
                        opacity: opacityButton}}
                    data-toggle="tooltip" data-placement="top" title={_("La extensión de este archivo es") + ' pdf'}
            >
                <div className='w-100 d-flex flex-row align-items-center'>
                    <div style={{width:'25px', height:'100%', position:'relative', top:'-2px', marginRight:'2.5px', marginLeft:'2.5px'}}>
                        <TbFileCertificate size={25} />
                    </div>
                    <div className='w-100 m-0 ml-1 d-flex justify-content-start flex-column'>
                        <p className='m-0' style={{fontFamily:'Rubik'}}>
                            {_('Exportar')} {_('Certificados')}
                        </p>
                        <p className='m-0' style={{fontFamily:'Rubik'}}>
                            {props.popUpMenu === true && 
                            `(${cardsGroupsSelectedCertificates} ${_('disponibles')})`}
                        </p>
                    </div>
                    <div className={classes.root}>
                        <div style={{width:'20px', height:'20px'}}></div>
                    </div>
                </div>
            </Button>
                <Modal show={show} onHide={handleClose} className="fade" style={{fontFamily:"Rubik"}}>
                    <Modal.Header>
                        <p style={{fontFamily:'Rubik' , margin:'0px', }}>{_('Exportar')} {_('Certificados')}</p>
                        <div className='close-button text-md' onClick={handleClose}>
                            x
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group className='mt-2' controlId="input_type">
                                <div className='d-flex flex-row'>
                                    <div className='ml-1'><Form.Label>{_('Agrupar Registros por')}:</Form.Label></div>
                                </div>
                                <Select name="input_type" required value={selectedValue} onChange={handleChange}>
                                    <MenuItem value="figuregroup">{_('Elemento')}</MenuItem>
                                    <MenuItem value="no_group">{_('No agrupar')}</MenuItem>
                                    <MenuItem value="protocol">{_('Protocolo')}</MenuItem>
                                </Select>
                            </Form.Group>
                            <Form.Group controlId="mergePdfCheckbox">
                                <Form.Check
                                type="checkbox"
                                label={'¿'+_('Exportar todo en un solo PDF')+'?'}
                                checked={isChecked}
                                onChange={handleCheckboxChange}
                                className='ml-0 mt-2'
                                />
                            </Form.Group>

                            <Form.Group controlId="manualSignaturesCheckbox">
                                <Form.Check type="checkbox" label={'¿' + _('Desea agregar firmas manuales en el certificado') + '?'} checked={manualSignatures} onChange={handleManualSignatureChange} />
                            </Form.Group>

                            <Form.Group controlId="withImagesCheckbox">
                                <Form.Check type="checkbox" label={_('Incluir Imágenes')} checked={withImages} onChange={handleSetWithImages} />
                            </Form.Group>

                            {manualSignatures && (
                                <>
                                    <Form.Group controlId="numberOfSignatures">
                                        <Form.Label>{_('Cantidad de Firmas manuales')}:</Form.Label>
                                        <Form.Control type="number" min="0" value={numberOfSignatures} onChange={handleNumberChange} />
                                    </Form.Group>
                                    {renderSelectInputs()}
                                </>
                            )}

                            <div className='d-flex justify-content-center mt-3 mb-1'>
                                <div style={{width:'42%', height:'40px'}}>
                                    <ExportButton name={'Certificados'} 
                                        endpoint={'web-api/certificates'} 
                                        postData={'postData'} 
                                        certificates={{ groupby: selectedValue, merge_pdf: isChecked, manualSignaturesCharges: charges, withImages: withImages }} 
                                        onStateToastChange={handleChildStateChange} 
                                        ext={'pdf'}
                                        disabled={isAnySelectEmpty()}
                                    ></ExportButton>
                                </div>
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>
        </>
    )
}

export default ExportCertificates;